/**
* Created For: 页面公用标题展示组件  $emit("backHandle"),this.$emit("rightHandle")
* Author: chenLiYan.
* Date: 2018/11/1 0001 14:47.
*/
<template>
  <div :class="['flex-none',isFixed?'fixed-title':'' ]">
    <div v-if="hasStatusBar" ref="statusBar" class="flex-none" :style="{ background: $store.state.statusBarColor,paddingTop: $store.state.statusBarH }"></div>
    <div :class="['title-box','text-ct',hasBorder ? 'border':'',styleType]">
      <template v-if="isShowBack">
        <span v-if="type === 'white'" class="sprite icon-arrow-left flex-none" @click="backHandle()"></span>
        <span v-else-if="type === 'blue'" class="sprite icon-arrow-left flex-none" @click="backHandle()"></span>
      </template>
      <p v-show="title" class="title">{{ title }}</p>
      <span v-show="btnText" class="right-btn" @click="rightHandle">{{ btnText }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageTitle',
  components: {},
  props: {
    // 标题名称
    title: {
      type: String,
      default: ''
    },
    // 标题类型，blue:蓝色背景，白字，white: 白底，黑字
    type: {
      type: String,
      default: 'white'
    },
    // 是否显示返回键
    isShowBack: {
      type: Boolean,
      default: true
    },
    // 右侧按钮文字 有值则显示
    btnText: {
      type: String,
      default: ''
    },
    // 是否有底线
    hasBorder: {
      type: Boolean,
      default: true
    },
    // 是否使用默认返回,false则$emit("backHandle")
    isDefaultBack: {
      type: Boolean,
      default: true
    },
    // 是否需填充手机状态栏
    hasStatusBar: {
      type: Boolean,
      default: false
    },
    // 是否fixed布局
    isFixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {}
  },
  computed: {
    // 标题栏样式
    // eslint-disable-next-line vue/return-in-computed-property
    styleType () {
      if (this.type === 'white') {
        return 'white-style'
      }
      if (this.type === 'blue') {
        return 'blue-style'
      }
    }
  },
  beforeMount () {},
  methods: {
    // 返回事件
    backHandle () {
      if (this.isDefaultBack) {
        this.goBack()
      } else {
        this.$emit('backHandle')
      }
    },
    // 右侧按钮点击事件
    rightHandle () {
      this.$emit('rightHandle')
    }
  }
}
</script>

<style lang="stylus" scoped>
    @import "../stylus/base/base.styl"
    .fixed-title{
        width 100%
        position fixed
        top:0
        left 0
        z-index 2
    }
    .title-box{
        position fixed
        height 88px
        width 100%
        z-index 2
        line-height 88px
        &.white-style{
            background $color-white
            color $color-font
        }
        &.blue-style{
            background $color-main
            color $color-white
        }
        &.border{
            border-bottom 1px solid $border-color
        }
        .sprite{
            position absolute
            left 20px
            top 50%
            z-index 2
            transform translate(0,-50%)
        }
        .title{
            width 620px
            font-size $font-XXXXL
            font-weight 700
            position absolute
            left 65px
            top 50%
            transform translate(0,-50%)
            $mixin-ellipsis()
        }
        .right-btn{
            font-size $font-XXL
            position absolute
            right 20px
            top 50%
            transform translate(0,-50%)
        }
    }
</style>
